import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className={`app-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>{sidebarCollapsed ? 'K' : 'Kamig'}</h2>
          <button className="sidebar-toggle" onClick={() => setSidebarCollapsed(!sidebarCollapsed)}>
            {sidebarCollapsed ? '\u25B6' : '\u25C0'}
          </button>
        </div>
        <nav className="sidebar-nav">
          <div className="nav-section">
            <span className="nav-section-title">{!sidebarCollapsed && 'Configuration'}</span>
            <NavLink to="/config/idps" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              <span className="nav-icon">{'\u2699'}</span>
              {!sidebarCollapsed && <span>IdP Configs</span>}
            </NavLink>
            <NavLink to="/config/policies" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              <span className="nav-icon">{'\ud83d\udccb'}</span>
              {!sidebarCollapsed && <span>Policies</span>}
            </NavLink>
          </div>
          <div className="nav-section">
            <span className="nav-section-title">{!sidebarCollapsed && 'Audit'}</span>
            <NavLink to="/audit/status" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              <span className="nav-icon">{'\ud83d\udcca'}</span>
              {!sidebarCollapsed && <span>Migration Status</span>}
            </NavLink>
            <NavLink to="/audit/logs" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              <span className="nav-icon">{'\ud83d\udcdd'}</span>
              {!sidebarCollapsed && <span>Activity Logs</span>}
            </NavLink>
          </div>
          <div className="nav-section">
            <span className="nav-section-title">{!sidebarCollapsed && 'Account'}</span>
            <NavLink to="/profile" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              <span className="nav-icon">{'\ud83d\udc64'}</span>
              {!sidebarCollapsed && <span>My Profile</span>}
            </NavLink>
            <NavLink to="/team" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              <span className="nav-icon">{'\ud83d\udc65'}</span>
              {!sidebarCollapsed && <span>My Team</span>}
            </NavLink>
          </div>
        </nav>
      </aside>
      <div className="main-area">
        <header className="top-bar">
          <div className="top-bar-left">
            <h3>IdP Migration Manager</h3>
          </div>
          <div className="top-bar-right">
            <span className="user-name">{user?.firstName} {user?.lastName}</span>
            <span className="user-role badge">{user?.role}</span>
            <button className="btn btn-sm btn-outline" onClick={handleLogout}>Logout</button>
          </div>
        </header>
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
